import {getQueryParams} from "@COMPONENTS/common/commonUtil";
import {device} from "@yb/utils";

const windowOption = "toolbar=0, status=0, width=626, height=436";
const title = "노랑풍선";

export default class Share {
	#url: string;

	constructor(baseUrl: string, parameter: string) {
		this.#url = `${baseUrl}${/^\?/.test(parameter) ? "" : "?"}${parameter}`;
	}

	get url() {
		return this.#url;
	}

	get search() {
		return getQueryParams(this.#url);
	}

	writeText() {
		if (device.isYBApp()) {
			const urlObj: HTMLInputElement = document.querySelector("#shortUrl");
			urlObj.focus();
			urlObj.setSelectionRange(0, 99999);
			if (document.execCommand("copy")) {
				alert("링크 복사가 완료되었습니다.\n원하는곳에 붙여넣기 해주세요.");
			}
		} else {
			navigator.clipboard
				.writeText(this.#url)
				.then(() => alert("링크 복사가 완료되었습니다.\n원하는곳에 붙여넣기 해주세요."));
		}
	}

	facebook() {
		const shareUrl = `http://www.facebook.com/share.php?u=${encodeURIComponent(this.#url)}`;
		window.open(shareUrl, "sharer", windowOption);
	}

	kakaostory() {
		const shareUrl = `https://story.kakao.com/s/share?url=${encodeURIComponent(this.#url)}`;
		window.open(shareUrl, "sharer", windowOption);
	}

	kakaotalk() {
		Kakao.Share.sendScrap({
			requestUrl: encodeURI(this.#url),
		});
	}

	naver() {
		const shareUrl = `https://share.naver.com/web/shareView.nhn?url=${encodeURI(
			encodeURIComponent(this.#url),
		)}&title=${encodeURIComponent(title)}`;
		window.open(shareUrl, "sharer", windowOption);
	}
}
